<template>

	<div class="form-wrapper">
		<div class="form-container"></div>
		<div class="form-loader">
			<div class="loader transition-fadeinup">
				<p>Loading form</p>
			</div>
		</div>

	</div>

</template>

<script>

import formCreator from '../../modules/forms/formCreator.js'
import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'
import formResourcesManager from '../../modules/forms/formResourcesManager.js'

export default {
	name: 'metadata',

	props: {
		entities: Array,
		markets: Object
	},

	watch: {
		entities: function (newVal, oldVal) {
			formResourcesManager.entities = newVal
			this.fetchEntity()
		},

		markets: function (newVal, oldVal) {
			formResourcesManager.markets = newVal
			this.getLanguagesCompleteHandler()
		}
	},

	data () {
		return {
			formData: null,
			mainslug: this.getMainSlug()
		}
	},

	created () {
		this.body = document.querySelector('body')
		this.body.classList.add('form-loading')
		formResourcesManager.reset()
		this.entityid = 30
		this.uuid = this.$route.params.id
		this.urlEntityid = this.$route.params.entityid
		this.int = 0

		if (this.entities) {
			formResourcesManager.entities = this.entities
			this.fetchEntity()
		}

		if (Object.keys(formResourcesManager.markets).length > 0) {
			this.getLanguagesCompleteHandler()
		} else {
			if (this.markets) {
				formResourcesManager.markets = this.markets
				this.getLanguagesCompleteHandler()
			}
		}
	},

	methods: {
		fetchEntity () {
			var entities = Object.values(formResourcesManager.entities)

			for (var i = entities.length - 1; i >= 0; i--) {
				if (entities[i].id == this.entityid) {
					this.getEntityCompleteHandler(entities[i])
				}
			}
		},

		getEntityCompleteHandler (entity) {
			if (!entity) this.$router.push('/content')
			this.entity = entity

			this.fetchFormData()
			this.fetchInstances()
		},

		fetchFormData () {
			var url = '/cms/api/forms?entity=30'
			xhrModule.get(url, this.getFormsCompleteHandler.bind(this))
		},

		getFormsCompleteHandler (forms) {
			// when there is no form data we will stop rendering
			if (Object.keys(forms.data).length === 0) return
			this.formData = forms.data[Object.keys(forms.data)[0]]
			this.renderForm()
		},

		getLanguagesCompleteHandler () {
			var data = formResourcesManager.markets

			// only strip out cms lang for entities other than users and roles
			if (this.entityid != 24 && this.entityid != 25) {
				// strip out the CMS language
				for (var l in data) {
					if (data[l].id === 1) delete data[l]
				}
			}

			this.languages = data
			this.renderForm()
		},

		fetchInstances () {
			if (!this.uuid) {
				this.instances = null
				this.renderForm()
			} else {
				var url = '/cms/api/metadata/data?uuid=' + this.uuid
				xhrModule.get(url, this.getInstancesCompleteHandler.bind(this))
			}
		},

		getInstancesCompleteHandler (instances) {
			this.instances = instances.data
			// this.instances = instances
			/*
			Object.keys(this.instances).map(i => {
				//this.instances[i].entity = instances.linked.entity[this.instances[i].entity]
				//this.instances[i].market = instances.linked.market[this.instances[].market]
				this.instances.linked.entity = instances.linked.entity[Object.keys(this.instances.linked.entity).pop()]
				this.instances.linked.market = instances.linked.market[Object.keys(this.instances.linked.market).pop()]
				//Object.keys(this.instances[i].data).map((k) => {
				Object.keys(this.instances.data).map((k) => {
					//this.instances[i].data[k] = {
					this.instances.data[k] = {
						//id: this.instances[i].data[k].id,
						id: this.instances.data[k].id,
						//property: Object.keys(this.instances[i].entity.properties).reduce((a, e) => {
						//	return this.instances[i].entity.properties[e].name === k ? this.instances[i].entity.properties[e] : a
						property: Object.keys(this.instances.linked.entity.properties).reduce((a, e) => {
							return this.instances.linked.entity.properties[e].name === k ? this.instances.linked.entity.properties[e] : a
						}),
						state: 3,
						//value: this.instances[i].data[k].value
						value: this.instances.data[k].value
					}
				})
			})
			*/
			/*
			Object.keys(this.instances).map(i => {
				this.instances[i].entity = instances.linked.entity[this.instances[i].entity]
				this.instances[i].market = instances.linked.market[this.instances[i].market]
				Object.keys(this.instances[i].data).map((k) => {
					this.instances[i].data[k] = {
						id: this.instances[i].data[k].id,
						property: Object.keys(this.instances[i].entity.properties).reduce((a, e) => {
							return this.instances[i].entity.properties[e].name === k ? this.instances[i].entity.properties[e] : a
						}),
						state: 3,
						value: this.instances[i].data[k].value
					}
				})
			})
			*/
			var inst = instances.data
			inst.entity = instances.linked.entity[inst.entity]
			inst.market = instances.linked.market[inst.market]

			Object.keys(inst.data).map((k) => {
				inst.data[k] = {
					id: inst.data[k].id,
					property: Object.keys(inst.entity.properties).reduce((a, e) => {
						return inst.entity.properties[e].name === k ? inst.entity.properties[e] : a
					}),
					state: 3,
					value: inst.data[k].value
				}
			})

			this.instances = [inst]
			this.renderForm()
		},

		renderForm () {
			this.int++
			if (this.int === 3) {
				this.body.classList.remove('form-loading')

				var container = document.querySelector('.form-container')
				formCreator({
					layout: 'multiple',
					data: this.formData,
					languages: this.languages,
					instances: this.instances,
					container: container,
					entity: this.entity,
					callback: this.postCompleted,
					editableReference: false
				}).init()
			}
		},

		postCompleted () {
			general.saveAnimation()
			this.$router.push('/' + this.mainslug + '/' + this.urlEntityid)
		},

		getMainSlug () {
			var pathName = window.location.pathname
			return pathName.split('/')[1]
		}
	}
}

</script>
